import RecipeSection from './recipe_section'

export default RecipeSection
